var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var DELETE_ELECTION_EVENT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation DeleteElectionEvent($electionEventId: String!) {\n        delete_election_event(election_event_id: $electionEventId) {\n            id\n        }\n    }\n"], ["\n    mutation DeleteElectionEvent($electionEventId: String!) {\n        delete_election_event(election_event_id: $electionEventId) {\n            id\n        }\n    }\n"])));
var templateObject_1;
